import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BreadscrumbService } from 'app/core/services';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-breadscrumb',
    templateUrl: './breadscrumb.component.html',
})
export class BreadscrumbComponent {
    breadsCrumb$: Observable<Array<any>>;

    constructor(
        private _breadscrumbService: BreadscrumbService,
        private _router: Router,
    ) {
        this.breadsCrumb$ = this._breadscrumbService
            .getBreadsCrumb$()
            .pipe(delay(0));
    }

    gotoTagLink(item: any): void {
        this._router.navigateByUrl(item?.url);
    }

    getTooltip(item: any): string {
        if (!item) {
            return '';
        }
        const name = item?.name ? decodeURIComponent(item.name) : '';
        const tooltip = item?.tooltip || '';
        return tooltip ? `${tooltip} - ${name}` : name;
    }
}
